<script>
import { authComputed } from '@state/helpers'

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <div class="page404">
    <div class="page404__box">
      <div class="page404__img">
        <template v-if="$appType() === 'ipetbooking'">
          <img :src="require(`@assets/images/logo-dark.svg`)" class="logo-pet" />
          <img :src="require(`@assets/images/login_logo.svg`)" class="logo-site ml-2" />
        </template>
        <template v-if="$appType() === 'dingbeauty'">
          <img :src="require(`@assets/images/dingBeauty-logo.svg`)" class="logo-site" />
        </template>
      </div>
      <div class="page404__content">
        <h1 class="fw-regular">
          Error 404 頁面連結錯誤
        </h1>
        <p class="my-4 text-text">很抱歉！目前無法連結到該頁面。
          <br>造成您的不便，敬請見諒。
        </p>
        <!-- <el-button v-if="loggedIn" @click="$router.push({ name: currentUser.redirect })">回到預設頁</el-button> -->
        <el-button type="primary" class="is-round w-100" @click="$router.push({ name: 'login' })">回到登入頁</el-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module></style>
